<template>
    <v-dialog v-if="displayAddressForm" v-model="displayAddressForm" max-width="600px" persistent class="elevation-0">
        <v-card flat :class="formClass">
            <v-card-title>
                <span class="headline">{{ title | translation }}</span>
            </v-card-title>
            <v-card-text>
                <span v-if="displayIncompleteAddressError" class="body-1 red--text ml-2">
                    {{incompleteAddressError | translation}}
                </span>

                <address-form
                    ref="form"
                    :address-fields.sync="localAddressFields"
                />
            </v-card-text>

            <v-card-actions :class="{'d-block': $vuetify.breakpoint.xs}">
                <v-spacer/>

                <v-btn
                    flat
                    @click="displayAddressForm = false"
                    :round="buttonRound"
                    :depressed="buttonDepressed"
                    :large="buttonLarge"
                    :block="$vuetify.breakpoint.xs"
                >
                    {{ 'Abort' | translation }}
                </v-btn>

                <v-btn
                    color="primary"
                    @click="applyAddressForm"
                    :round="buttonRound"
                    :depressed="buttonDepressed"
                    :large="buttonLarge"
                    :block="$vuetify.breakpoint.xs"
                    :class="{'ma-0': $vuetify.breakpoint.xs}"
                >
                    {{ 'Take over' | translation }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'AddressFormModal',
        props: {
            value: Boolean,
            formClass: '',
            displayIncompleteAddressError: Boolean,
            incompleteAddressError: '',
            buttonRound: Boolean,
            buttonDepressed: Boolean,
            buttonLarge: Boolean,
            addressFields: {
                street: undefined,
                houseNumber: undefined,
                postCode: undefined,
                city: undefined,
                country: undefined,
            },
            title: {
                type: String,
                default: 'Address*',
            }
        },
        data() {
            return {
                intermediateLocalAddressFields: {},
            };
        },
        computed: {
            displayAddressForm: {
                get() {
                    return this.value;
                },
                set(value) {
                    return this.$emit('input', value);
                },
            },
            localAddressFields: {
                get() {
                    return Object.assign({}, this.addressFields);
                },
                set(val) {
                    this.intermediateLocalAddressFields = val;
                },
            },
        },
        methods: {
            applyAddressForm() {
                if (this.$refs.form.validate()) {
                    this.$emit('update:addressFields', this.intermediateLocalAddressFields);
                    this.$emit('submit');
                }
            },
        },
    };
</script>